import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router'
import { useHelpTool } from '@/hooks';
import { queryEvent } from "@/api";


export default {
  __name: 'TopBanner',
  setup(__props) {

const router = useRouter()
const { doEnterGame, openBrowser } = useHelpTool()

const eventList = ref([]);

onMounted(() => {
  fetchEvent();
})

const fetchEvent = () => {
  queryEvent().then(res => {
    eventList.value = res.data || [];
  });
}

const doGo = item => {
  const { action, actionContent, actionData } = item || {}
  if (action === 'url') {
    openBrowser(actionContent);
  } else if (action === 'game') {
    doEnterGame(actionContent);
  } else if (action === 'page') {
    if(actionContent == 'recharge' && actionData) {
      const { type, product } = actionData;
      if(type === 'exchange') {
        router.push({ name: 'exchange' })
      } else {
        router.push({ name: 'recharge', query: { product } })
      }
    } else {
      router.push({ name: actionContent })
    }
  }
}

return (_ctx, _cache) => {
  const _component_van_loading = _resolveComponent("van-loading")
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")
  const _component_van_swipe = _resolveComponent("van-swipe")

  return (_openBlock(), _createBlock(_component_van_swipe, {
    class: "banner-swipe",
    autoplay: 3000
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(eventList.value, (item) => {
        return (_openBlock(), _createBlock(_component_van_swipe_item, {
          key: item.level
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_image, {
              fit: "contain",
              src: item.img || '-',
              "error-icon": require('@/assets/img/game/game.png'),
              onClick: $event => (doGo(item))
            }, {
              loading: _withCtx(() => [
                _createVNode(_component_van_loading, {
                  type: "spinner",
                  color: "#ADB5BF",
                  size: "24"
                })
              ]),
              _: 2
            }, 1032, ["src", "error-icon", "onClick"])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}
}

}